import React from "react"
import styles from "./RadioButton.module.scss"
import classnames from "classnames"

export const RadioButton = ({ checked, label, onClick }) => (
  <div className="mb-2 cursor-pointer" onClick={onClick}>
    <span
      className={classnames(styles.radio, "mr-2")}
      style={{ borderColor: checked ? "black" : "#D9DADB" }}>
      {checked && <span className={styles.inner} />}
    </span>
    <span
      className={classnames("fs-14px", {
        "text-black": !checked,
        "fw-600": checked,
      })}>
      {label}
    </span>
  </div>
)
